import { externalPages } from "utilities/externalPages";

import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTIconExternalLink } from "commonComponents/btWrappers/BTIcon";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import HomeDepotProXtraLogo from "commonComponents/entity/vendor/HomeDepotLogo/HomeDepotProXtraLogo";

import { type HomeDepotSettingsFormActions } from "entity/vendor/HomeDepotSettings/HomeDepotSettings.api.types";

interface IHomeDepotInterstitialDisplayProps {
    /**
     * Action being performed
     */
    actionBeingPerformed: HomeDepotSettingsFormActions;
    /**
     * On click handler
     */
    onClick: () => void;
}

export const HomeDepotInterstitialDisplay: React.FunctionComponent<
    IHomeDepotInterstitialDisplayProps
> = (props) => (
    <div data-testid="homeDepotInterstitialPage">
        <HomeDepotProXtraLogo height={56} />
        <BTRow className="margin-vertical-md">
            <BTCol md={12}>
                <BTTitle>
                    Authorize Buildertrend to securely share your data to The Home Depot
                </BTTitle>
            </BTCol>
        </BTRow>
        <BTRow className="margin-vertical-md">
            <BTCol md={12}>
                By clicking <strong>Sign In to Connect</strong>, you are agreeing to share data
                between your Buildertrend and your Pro Xtra account at The Home Depot. This will
                grant The Home Depot access to certain information within your Buildertrend account.
            </BTCol>
        </BTRow>
        <BTRow className="margin-vertical-md">
            <BTCol md={12}>
                For more information on your relationship with Buildertrend and its privacy
                practices, please see Buildertrend's{" "}
                <BTExternalLink href={externalPages.BuildertrendTermsAndConditions} isUnderline>
                    Terms and Conditions Agreement
                </BTExternalLink>{" "}
                and{" "}
                <BTExternalLink href={externalPages.BuildertrendPrivacyPolicy} isUnderline>
                    Privacy Policy
                </BTExternalLink>
                .
            </BTCol>
        </BTRow>
        <BTRow className="margin-vertical-md">
            <BTCol md={12}>
                To learn more about your relationship with The Home Depot and the treatment of your
                data, please see The Home Depot's{" "}
                <BTExternalLink href={externalPages.HomeDepotTermsAndConditions} isUnderline>
                    Terms of Use
                </BTExternalLink>{" "}
                and{" "}
                <BTExternalLink href={externalPages.HomeDepotPrivacyPolicy} isUnderline>
                    Privacy and Security Statement
                </BTExternalLink>
                .
            </BTCol>
        </BTRow>
        <BTRow className="margin-vertical-md">
            <BTCol md={12}>
                Once connected, you can disconnect from your Pro Xtra account at The Home Depot from
                The Home Depot settings page.
            </BTCol>
        </BTRow>
        <BTRow className="margin-top-md">
            <BTCol md={12}>
                <BTButtonDeprecated<HomeDepotSettingsFormActions>
                    type="primary"
                    data-testid="signInToConnect"
                    loadingAction="connect"
                    actionBeingPerformed={props.actionBeingPerformed}
                    onClick={props.onClick}
                >
                    Sign In to Connect <BTIconExternalLink />
                </BTButtonDeprecated>
            </BTCol>
        </BTRow>
    </div>
);
